/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=07062b46"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=07062b46&lang=css"
import "./App.vue?vue&type=style&index=1&id=07062b46&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__